import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-zoom-in",
  "use": "icon-zoom-in-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-zoom-in\"><path d=\"M823.7 161.5H561.3v64h190L540.2 436.6l45.2 45.2 212.4-212.4v190h64V199.6c0-21-17.1-38.1-38.1-38.1zM437 544.1L224.6 756.4v-190h-64v259.8c0 21 17.1 38.1 38.1 38.1h262.4v-64h-190l211.1-211.1-45.2-45.1z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol